import * as React from "react";

import { StaticImage } from "gatsby-plugin-image";

import * as S from './styles';

export default function Panel({ step }) {
  const lstStep = [
    'Register your details',
    'Record Content',
    'Get Paid!',
  ];

  return (
    <S.Container>
      <S.Content>
        { step === 1 &&
        <StaticImage
          src={`../../images/step-1.png`}
          alt="Step one"
          placeholder="blurred"
          layout="fixed"
          width={153}
          height={180}
          />
        }
        { step === 2 &&
        <StaticImage
          src={`../../images/step-2.png`}
          alt="Step two"
          placeholder="blurred"
          layout="fixed"
          width={61}
          height={215}
          />
        }
        { step === 3 &&
        <StaticImage
          src={`../../images/step-3.png`}
          alt="Step three"
          placeholder="blurred"
          layout="fixed"
          width={205}
          height={103}
          />
        }
      </S.Content>
      <S.Text>{lstStep[step-1]}</S.Text>
    </S.Container>
  )
}